import { gql } from '@apollo/client';
import { ADMIN_AUTH_RESPONSE_FRAGMENT, AdminAuthResponse } from "../shared";
import { ADD_SAVED_VIEW_RESPONSE_FRAGMENT, AddSavedViewResponse, SavedView, SavedViewRole, SavedViewUser } from './savedViewFragments';

export type AddSavedViewArgs = {
  savedView: Pick<SavedView, 'name' | 'app' | 'appVersion' | 'viewstate'> & {
    roleIds?: Array<SavedViewRole['roleId']>;
    userIds?: Array<SavedViewUser['userId']>;
  };
};

export type AddSavedViewResponseData = {
  addSavedView: AddSavedViewResponse;
};

export type DeleteSavedViewArgs = {
  id: SavedView['id'];
};

export type DeleteSavedViewResponseData = {
  deleteSavedView: AdminAuthResponse;
};

export const ADD_SAVED_VIEW_MUTATION = gql`
  mutation AddSavedView($savedView: AddSavedViewInput!) {
    addSavedView(savedView: $savedView) {
      ...AddSavedViewResponseFragment
    }
  }
  ${ADD_SAVED_VIEW_RESPONSE_FRAGMENT}
`;

export const DELETE_SAVED_VIEW_MUTATION = gql`
  mutation DeleteSavedView(
    $id: String!
  ) {
    deleteSavedView(
      id: $id
    ) {
      ...AdminAuthResponseFragment
    }
  }
  ${ADMIN_AUTH_RESPONSE_FRAGMENT}
`;
